// extracted by mini-css-extract-plugin
export default {"cards":"HomeCardsSection_cards__Rp1qw","cards__card":"HomeCardsSection_cards__card__zXw5R"};